import { ReactNode } from 'react';
import { Box, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  title: string;
  description?: ReactNode;
  headerRight?: ReactNode;
  children?: ReactNode;
};

export function MeetingDetailsCard({ title, description, headerRight, children }: Props) {
  return (
    <Box p="md" style={{ border: '1px solid var(--mantine-color-gray-1)', borderRadius: 16 }}>
      <Flex justify="space-between" align="center" gap="sm">
        <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="gray.10">
          {title}
        </Text>
        {headerRight}
      </Flex>

      {description !== undefined && (
        <Box mt="xs">
          {typeof description === 'string' ? (
            <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
              {description}
            </Text>
          ) : (
            description
          )}
        </Box>
      )}

      {children && <Box mt="sm">{children}</Box>}
    </Box>
  );
}
